import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for the dispatches sub-tree (register at `/sales-invoicing/
 * dispatches`, detail at `/sales-invoicing/dispatches/$dispatchId`) — mirrors
 * `silo-counts/counts.tsx`'s identical pattern. No chrome of its own; the parent
 * `sales-invoicing.tsx` layout already renders the tab strip. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/dispatches')({
  component: () => <Outlet />,
});
